import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  includeLatestBooking: false,
  includeLatestSurvey: false
};

const respondentIncludeFilterSlice = createSlice({
  name: 'respondentIncludeFilter',
  initialState,
  reducers: {
    setIncludeLatestBooking: (state, action) => {
      state.includeLatestBooking = action.payload;
    },
    setIncludeLatestSurvey: (state, action) => {
      state.includeLatestSurvey = action.payload;
    }
  }
});

export const { setIncludeLatestBooking, setIncludeLatestSurvey } = respondentIncludeFilterSlice.actions;
export default respondentIncludeFilterSlice.reducer;
